import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
const CustomProductActionBottom = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,
  mt: 0,
  mb: 1,
  pt: 2,
  borderTop: "1px solid #e0e0e3",
}));
export default CustomProductActionBottom;
